import { render, staticRenderFns } from "./SwapButtonNew.vue?vue&type=template&id=7da3e142&scoped=true"
import script from "./SwapButtonNew.vue?vue&type=script&lang=ts"
export * from "./SwapButtonNew.vue?vue&type=script&lang=ts"
import style0 from "./SwapButtonNew.vue?vue&type=style&index=0&id=7da3e142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da3e142",
  null
  
)

export default component.exports